<div class="preference-group group raised-card">
    <h2>Update Email/Username</h2>
    
    <b2c-content-host [b2cFrameSource]="b2cFrameSource" [b2cFrameHeight]="b2cFrameHeight"></b2c-content-host>
</div>